import React from 'react';
import { Grid, Typography} from "@material-ui/core";
import '../../App.css'
import './workStyles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import one from '../../img/one.svg';
import two from '../../img/two.svg';
import three from '../../img/three.svg';
import four from '../../img/four.svg';


function OurWorkWhyPantheon() {
  const globalClasses = globalUseStyles()
  return (
    <ThemeProvider theme={theme}>
        <Container disableGutters className={"workWhyStyle"} maxWidth={false} component="section">
            <Container disableGutters className={"workWhyStyleInner"} maxWidth={false} component="section">
                <Grid className={globalClasses.containerVertPadding} container>
                    <Grid className={globalClasses.containerSmall} container >
                    <Grid item xs={12} md={12}  >
                        <Typography  variant="subtitle1">How We Do It</Typography>
                        <Typography  variant="h2">Why Pantheon</Typography>
                    </Grid>
                    <Grid className={globalClasses.topBottomSpacing} xs={12} md={6} container>
                        <Grid item xs={false} md={2}>
                            <img src={one} alt="one"/>
                        </Grid>
                        <Grid item xs={12} md={10}  >
                            <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                                <Typography className={globalClasses.bold}  variant="h5">Product Mindset</Typography>
                                <Typography  variant="body1">We believe that technology solutions are founded upon a product mindset, which focuses on iterative, continual improvements based on feedback loops and usage data.   </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className={globalClasses.topBottomSpacing} xs={12} md={6} container>
                        <Grid item xs={false} md={2}>
                            <img src={two} alt="two" />
                        </Grid>
                        <Grid item xs={12} md={10}  >
                            <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                                <Typography className={globalClasses.bold} variant="h5">Human-Centered Design</Typography>
                                <Typography  variant="body1">Our design team works to understand your users' goals and motivations – we base our design decisions on data, not opinions.  </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className={globalClasses.topBottomSpacing} xs={12} md={6} container>
                        <Grid item xs={false} md={2}>
                            <img src={three} alt="three"/>
                        </Grid>
                        <Grid item xs={12} md={10}  >
                            <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                                <Typography className={globalClasses.bold} variant="h5">Continual Improvement</Typography>
                                <Typography  variant="body1">We understand there can be many dependent variables that play into a product vision and how it may frequently change over time. Our process allows us to deliver products that adjust to your chaning priorities over time while still delivering value now.  </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className={globalClasses.topBottomSpacing} xs={12} md={6} container>
                        <Grid item xs={false} md={2}>
                            <img src={four} alt="four"/>
                        </Grid>
                        <Grid item xs={12} md={10}  >
                            <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                                <Typography className={globalClasses.bold} variant="h5">Outcome Oriented</Typography>
                                <Typography  variant="body1">By focusing on the objectives of the product from the user and business perspective, we aim to ensure that products and features solve the problems you’ve identified and drive value for your organization. </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Container>
    </ThemeProvider>
  );
};

export default OurWorkWhyPantheon;